import { render } from "./IconSettings.vue?vue&type=template&id=8908bc58"
import script from "./IconSettings.vue?vue&type=script&lang=ts"
export * from "./IconSettings.vue?vue&type=script&lang=ts"
script.render = render

export default script